import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-template-preview',
  templateUrl: './template-preview.component.html',
  styleUrls: ['./template-preview.component.scss']
})
export class TemplatePreviewComponent implements OnInit {
  @Input() template;
  constructor() { }

  ngOnInit(): void {
  }

}
